import { render, staticRenderFns } from "./FlashBoxSizeSelector.vue?vue&type=template&id=98a473c8&scoped=true"
import script from "./FlashBoxSizeSelector.vue?vue&type=script&lang=js"
export * from "./FlashBoxSizeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a473c8",
  null
  
)

export default component.exports